import type { PostIndex } from '../models/PostIndex.ts';
import { assert } from '../utils/assert.ts';
import { type AsyncResult, useAsync } from './useAsync.ts';

const STORAGE_KEY = 'blog-index';
let fetchPromise: Promise<Response> | undefined;

export function usePostIndex(): AsyncResult<PostIndex> {
  return useAsync(
    async (signal) => {
      const res = await (fetchPromise ??= fetch('/blog/index.json', { signal }).finally(
        () => (fetchPromise = undefined),
      ));

      assert(res.ok, 'Failed to fetch blog index.');
      const value = (await res.json()) as PostIndex;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      return value;
    },
    [],
    {
      initial: () => {
        try {
          const cached = localStorage.getItem(STORAGE_KEY);
          return cached != null ? (JSON.parse(cached) as PostIndex) : undefined;
        } catch {
          return undefined;
        }
      },
    },
  );
}
